import { getClient } from './client';
import { parsePage } from './pageParsers';
import {
    getCompanyTopicQuery,
    getExcludeQuery,
    getIndustryQuery,
    getServicesQuery,
    getSolutionQuery,
    getTechnologyQuery,
} from './queries';

const getAuthorQuery = (authorPageId: string | string[]) => {
    return {
        'fields.authors.sys.id[in]': Array.isArray(authorPageId) ? authorPageId.join(',') : authorPageId,
    };
};

type GetJournalProps = {
    preview?: boolean;
    limit?: number;
    solutionId?: string | string[];
    technologyId?: string | string[];
    serviceId?: string | string[];
    companyTopicId?: string | string[];
    industryId?: string | string[];
    authorPageId?: string | string[];
    excludeId?: string | string[];
};

export const getJournal = async (props: GetJournalProps) => {
    const {
        preview = false,
        limit = 100,
        solutionId,
        technologyId,
        serviceId,
        companyTopicId,
        excludeId,
        industryId,
        authorPageId,
    } = props;

    const query = {
        limit,
        include: 10,
        content_type: 'pageJournal',
        order: '-fields.publishDate',
        ...(solutionId && getSolutionQuery(solutionId)),
        ...(technologyId && getTechnologyQuery(technologyId)),
        ...(serviceId && getServicesQuery(serviceId)),
        ...(companyTopicId && getCompanyTopicQuery(companyTopicId)),
        ...(industryId && getIndustryQuery(industryId)),
        ...(authorPageId && getAuthorQuery(authorPageId)),
        ...(excludeId && getExcludeQuery(excludeId)),
    };

    console.log({ query });

    const { items: pages } = await getClient(preview).withoutUnresolvableLinks.getEntries(query);

    return pages ? pages.map((page) => parsePage(page)) : [];
};
